import { render, staticRenderFns } from "./MemberSummaryReport.vue?vue&type=template&id=5533f7a8&scoped=true&"
import script from "./MemberSummaryReport.vue?vue&type=script&lang=js&"
export * from "./MemberSummaryReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5533f7a8",
  null
  
)

export default component.exports